module.exports = __webpack_public_path__ + "static/media/angular3.b4e450a7.png";